export function xy_graph_V(GraphV) {

    // define process
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 0 - concept
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let branch_open = false
    let first_development = false
    let vid_L0 = 0

    // default width
    let xW = 1000
    let yH = 1000
        // range of H of Level
    let minH = 50
    let maxH = 200
    let sumX = 0

    // find H of Level
    let y_h = xW / (GraphV.info.max_level + 1)

    if (y_h > maxH) {
        GraphV.info.lv_height = maxH
        yH = maxH * (GraphV.info.max_level + 1)
    } else if (y_h < minH) {
        GraphV.info.lv_height = minH
        yH = minH * (GraphV.info.max_level + 1)
    } else {
        GraphV.info.lv_height = y_h
        yH = xW
    }
    GraphV.info.max_x = xW
    GraphV.info.max_y = yH

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 1 - level 0 - single node
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // ///temporal test - delete after testing
    // if (GraphV.vertex_levels[0].length > 1) {
    //     console.log("[ERROR] check single vertex in level 0 ")
    // }
    // if (GraphV.info.max_level == 0) {
    //     console.log("[ERROR] check Number of Levels")
    // } ////temporal test -


    let start_vid = GraphV.vertex_levels[0][0]
    vid_L0 = start_vid
    let startV = GraphV.vertex_library[start_vid]

    let xCoef = xW / (2 * startV.position.xd)

    startV.position.x = xW / 2
    startV.position.y = 0

    GraphV.vertex_table.push({
        vid: start_vid,
        x: startV.position.x,
        y: startV.position.y,
        n_nodes: startV.n_nodes,
        nodes: startV.nodes,
        in_d: startV.nd_din.R,
        xwidth: xCoef * startV.position.xd
    })

    // for reposition of vertexes before after first_development
    let vid_before_development = [start_vid]

    // project link - temporary positioning of out vertexes from startV
    let vids_rank1 = GraphV.vertex_library[start_vid].v_outs.total
    let num_rank1 = vids_rank1.length
        // vids_rank1 sort by level
    vids_rank1.sort(function(a, b) {
            let va = GraphV.vertex_library[a]
            let vb = GraphV.vertex_library[b]
            return va.level < vb.level ? -1 : va.level > vb.level ? 1 : 0
        })
        // distribute x position within +-45degree
    let x_start = xW / 2 - 1.5 * GraphV.info.lv_height
    let dXSpan = (3 * GraphV.info.lv_height) / (num_rank1 + 1)
    let countR1 = 1
    vids_rank1.forEach(v => {
        let vR1 = GraphV.vertex_library[v]
        vR1.position.x = x_start + countR1 * dXSpan
        vR1.position.y = vR1.level * GraphV.info.lv_height
        countR1 += 1
    })

    // console.log("[XY] start Level 0 : ", startV)



    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 2 - level 1++ 
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //vertexes id in a level
    let vs_in_L = []
    let vs_sorted = []
    let vs_rest = []
    let v_first = null
    let vouts_cumul_max = 0

    // num_vs : number of vertices in level
    let num_vs = 0



    // loop for levels. start from level 1
    for (let lv = 1; lv < GraphV.info.max_level + 1; lv++) {

        //vs_in_L : vertices in a level
        vs_in_L = GraphV.vertex_levels[lv]

        let emptyLevel = false

        //num_vs : number of vertices in a level
        if (vs_in_L.length > 0) {
            num_vs = vs_in_L.length
        } else {
            emptyLevel = true
        }

        // console.log("[FUNCTIONS] tree_xy - position level ", lv, " - number of v : ", num_vs)

        //branch_open : after first development.
        if (num_vs > 1 && !branch_open) {
            first_development = true
                //and after branch open
        } else if (branch_open) {
            first_development = false
        } else if (!emptyLevel) {
            // not yet branch open and num_vs = 1
            vid_before_development.push(vs_in_L[0])
        }

        // when first_development
        if (first_development && !emptyLevel) {

            // console.log("[XY] LEVEL ", lv, " - first_development ", vs_in_L)

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // 2.1 - first development  
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////

            vs_sorted = []
            vouts_cumul_max = 0

            //v_first : far left vertex
            v_first = null

            vs_in_L.forEach(v => {
                //find a vertex of maximum v_outs.cumulative for far left vertex
                if (GraphV.vertex_library[v].v_dout.cumul >= vouts_cumul_max) {
                    vouts_cumul_max = GraphV.vertex_library[v].v_dout.cumul
                    v_first = v
                }
            })

            vs_sorted.push(v_first)
            vs_rest = vs_in_L.filter(v => v != v_first)

            //////////////////////////////
            // for sorting by distance 
            //////////////////////////////

            let n_vs_rest = vs_rest.length
            let distance_near = 0

            //distance a: between outs, x: between outs_extended, s: synthetic
            let distance_a = 0
            let distance_x = 0
            let distance_s = 0

            let vFirst_outs = []
            let vFirst_outs_ext = []
            let vRest_outs = []
            let vRest_outs_ext = []

            let v_select = null
            let v_nearest = null

            //////////////////////////////
            // core - sorting by distance 
            //////////////////////////////

            while (n_vs_rest > 0) {

                //find nearest with v_first in n_vs_rest
                vFirst_outs = GraphV.vertex_library[v_first].v_outs.total
                vFirst_outs_ext = GraphV.vertex_library[v_first].v_outs.ext
                distance_near = 0

                for (let vr = 0; vr < n_vs_rest; vr++) {
                    v_select = vs_rest[vr]
                    vRest_outs = GraphV.vertex_library[v_select].v_outs.total
                    vRest_outs_ext = GraphV.vertex_library[v_select].v_outs.ext

                    distance_a = distance_ab(vFirst_outs, vRest_outs)
                    distance_x = distance_ab(vFirst_outs_ext, vRest_outs_ext)

                    // modulating this distance synthetic
                    distance_s = distance_a + 0.5 * distance_x

                    if (distance_near <= distance_s) {
                        distance_near = distance_s
                        v_nearest = v_select
                    }
                }
                vs_sorted.push(v_nearest)

                //reset v_first and vs_rest
                vs_rest = vs_rest.filter(v => v != v_nearest)
                v_first = v_nearest
                n_vs_rest = vs_rest.length

                //double exit
                if (n_vs_rest.length == 0) {
                    break;
                }
            }

            // replace sorted
            GraphV.vertex_levels[lv] = JSON.parse(JSON.stringify(vs_sorted))

            //////////////////////////////
            // position x , y 
            //////////////////////////////


            let x_right = 0
            let vid_o = null
            let vertex_o = {}
            let exceed_rightend = false
            let x_rightend = xW

            for (let v_ordered = 0; v_ordered < vs_sorted.length; v_ordered++) {
                vid_o = vs_sorted[v_ordered]
                vertex_o = GraphV.vertex_library[vid_o]
                    //position.xd -> delta x
                vertex_o.position.x = x_right + xCoef * vertex_o.position.xd

                //consideration of lower vertex positionx of v
                // considerLowerV //////////////////////////////
                let cLowerV = 0.5
                    ////////////////////////////////////////////////

                let avgXLower = 0
                let LowerVs = vertex_o.v_ins.ext
                LowerVs.forEach(v => {
                    avgXLower += GraphV.vertex_library[v].position.x
                })
                avgXLower = avgXLower / vertex_o.v_din.ext

                vertex_o.position.x = cLowerV * avgXLower + (1 - cLowerV) * vertex_o.position.x
                vertex_o.position.y = lv * GraphV.info.lv_height
                x_right += 2 * xCoef * vertex_o.position.xd
                    // console.log("first dev. v ", vertex_o)

                if (vertex_o.position.x > GraphV.info.max_x) {
                    // console.log("[ERROR] position x : exceed upper x of canvas ", GraphV.info.max_x, vertex_o.position.x)
                    exceed_rightend = true
                    x_rightend = vertex_o.position.x
                }

                sumX += vertex_o.position.x

                GraphV.vertex_table.push({
                    vid: vid_o,
                    x: vertex_o.position.x,
                    y: vertex_o.position.y,
                    n_nodes: vertex_o.n_nodes,
                    nodes: vertex_o.nodes,
                    in_d: vertex_o.nd_din.R,
                    xwidth: xCoef * vertex_o.position.xd
                })
            }
            // xy shifting of vertex_table when exceeding rightend
            let xMultiply = 1

            if (exceed_rightend) {

                // console.log("[XY] LEVEL ", lv, " reposition vertexex ", vid_before_development)

                xMultiply = x_rightend / xW

                vid_before_development.forEach(vb => {
                    let vBL = GraphV.vertex_library[vb]
                    vBL.position.x = vBL.position.x * xMultiply

                    // console.log("[XY] LEVEL ", lv, " vertex to deplace ", vBL)

                    let vB_list = GraphV.vertex_table.filter(v => v.vid == vb)
                    let vBT = vB_list[0]

                    if (vB_list.length > 1) {
                        // console.log("[ERROR] vid in vertex_table must be unique ", vB_list)
                    }

                    // console.log("[XY] LEVEL ", lv, "deplace x of vertex_table V :", vb, vB_list, vBT)

                    vBT.x = vBT.x * xMultiply
                    vBT.y = vBT.y * xMultiply
                        // GraphV.info.lv_height = GraphV.info.lv_height * xMultiply
                })
            }
            // console.log("[XY] LEVEL ", lv, " xW, new xW, multiply, ", xW, x_rightend, xMultiply)
            xW = x_rightend
            GraphV.info.max_x = x_rightend
                // console.log("[XY] LEVEL ", lv, " dimension ", xW, GraphV.info.lv_height * GraphV.info.max_level)

            branch_open = true
                // console.log("[FUNCTIONS] tree_xy - first development & branch open ", GraphV)

        } else if (branch_open && !emptyLevel) {

            // console.log("[XY] LEVEL ", lv, " - after branch open ", lv * GraphV.info.lv_height)

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // 2.2 - make position of V by lower levels  
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////

            // range of x position in a level
            let level_posx_lower = 0
            let level_posx_upper = 0

            let v_working_id = null
            let v_work = {}

            //for adjusting the center of position x distribution
            let pos_xs = 0
            let temp_x = 0

            let x_intercept = 0

            // range of inV of a vertex in level x
            let x_leftend = 0
            let x_rightend = 0
            let y_delta = 0

            //x of project is not considered
            let vL0_count = 0

            // console.log("After first dev. level: ", lv, " num_vs: ", num_vs)

            for (let v_l = 0; v_l < num_vs; v_l++) {
                v_working_id = vs_in_L[v_l]
                v_work = GraphV.vertex_library[v_working_id]

                pos_xs = 0
                temp_x = 0
                y_delta = 0
                vL0_count = 0

                if (v_work.v_din.ext == 0) {
                    // console.log("[ERROR] v ins must not be zero", v_work)
                } else {
                    let in_v = {}

                    for (let i = 0; i < v_work.v_din.ext; i++) {

                        in_v = v_work.v_ins.ext[i]

                        //exception vertex level 0 for calculate position x
                        if (in_v == vid_L0) {
                            vL0_count = 1
                        } else {
                            temp_x = GraphV.vertex_library[in_v].position.x
                            pos_xs += temp_x

                            if (i == 0) {
                                x_leftend = temp_x
                                x_rightend = temp_x
                            } else {
                                if (temp_x < x_leftend) { x_leftend = temp_x }
                                if (temp_x > x_rightend) { x_rightend = temp_x }
                            }
                        }
                    }
                    v_work.position.x = pos_xs / (v_work.v_din.ext - vL0_count)

                    ////////////////////////////////////////////////////////////
                    ////////  y_delta_coef /////////////////////////////////////
                    let calib_ydC = 0.5
                        //level ++ -> delta ++ : range [0,1]
                    let ydCoef = calib_ydC * (lv - 1) / GraphV.info.max_level
                        ////////////////////////////////////////////////////////////
                        ////////////////////////////////////////////////////////////

                    y_delta = ydCoef * GraphV.info.lv_height * (x_rightend - x_leftend) / GraphV.info.max_x
                    v_work.position.y = lv * GraphV.info.lv_height + y_delta

                    //for range of all vertexes in a level
                    //v_l : first
                    if (v_l == 0) {
                        level_posx_lower = v_work.position.x
                        level_posx_upper = v_work.position.x
                    } else {
                        if (v_work.position.x < level_posx_lower) { level_posx_lower = v_work.position.x }
                        if (v_work.position.x > level_posx_upper) { level_posx_upper = v_work.position.x }
                    }
                }
            }
            if (x_rightend > GraphV.info.max_x) {
                GraphV.info.max_x = x_rightend
            }
            xW = GraphV.info.max_x

            let sorted_vs = []

            // stretching position x
            let slope = xW / (level_posx_upper - level_posx_lower + 1)
            x_intercept = -slope * level_posx_lower + 1

            let px = null
            vs_in_L.forEach(v => {
                px = GraphV.vertex_library[v].position.x

                // stretching position x to full x Width///////////
                // w = 1 : before position
                // w = 0 : fit xW
                let w = 0.7
                    ////////////////////////////////////////////////////////////

                GraphV.vertex_library[v].position.x = w * px + (1 - w) * (slope * px + x_intercept)

                sorted_vs.push({ vid: v, px: GraphV.vertex_library[v].position.x })

            })

            //sorting
            sorted_vs.sort(function(a, b) {
                    return a.px < b.px ? -1 : a.px > b.px ? 1 : 0
                })
                // console.log("sorted_vs after ", sorted_vs)
            vs_in_L = sorted_vs.map(v => { return v.vid })

            // distance between vertexes ////////////////////////////
            // w_band = 0 : range of vs in level
            // w_band = 1 : range of vs with xW
            ////////////////////////////////////////////////////////////

            let w_band = 0.5
            let x_delta = ((1 - w_band) * (level_posx_upper - level_posx_lower + 1) + w_band * xW) / num_vs

            let posx = null
            let vertex_final = {}

            // console.log("Level ", lv, " num_vertices ", num_vs)

            for (let xd = 0; xd < num_vs; xd++) {
                vertex_final = JSON.parse(JSON.stringify(GraphV.vertex_library[vs_in_L[xd]]))

                // console.log("vertex_final ", vertex_final)
                if (vertex_final.v_din.total == 1) {
                    // keep the x position of lower v
                    let vid_before = vertex_final.v_ins.total[0]
                    let vertex_before = GraphV.vertex_library[vid_before]
                    vertex_final.position.x = vertex_before.position.x
                }
                if (num_vs != 1) {
                    posx = vertex_final.position.x

                    /////// distribute evenly
                    // distEven = 0 : keep the position x
                    // distEven = 1 : distribute evenly
                    let distEven = 0.5
                    vertex_final.position.x = (1 - distEven) * posx + distEven * (level_posx_lower + xd * x_delta)
                }

                sumX += vertex_final.position.x

                GraphV.vertex_library[vs_in_L[xd]] = vertex_final
                GraphV.vertex_table.push({
                    vid: vs_in_L[xd],
                    x: vertex_final.position.x,
                    y: vertex_final.position.y,
                    n_nodes: vertex_final.n_nodes,
                    nodes: vertex_final.nodes,
                    in_d: vertex_final.nd_din.R,
                    xwidth: x_delta
                })
                GraphV.vertex_library[vs_in_L[xd]] = vertex_final
            }
        } else if (!emptyLevel) {
            ///////////////////////////////////////////////////////////////
            // before first development and not yet branch open : num v = 1
            ///////////////////////////////////////////////////////////////

            // console.log("[XY] LEVEL ", lv, " - not yet branch open ", vs_in_L)

            let aVid = vs_in_L[0]

            // to Do: check need to JSON.pars(JSON.stringify())
            // if necessary, rewrite aV to vertex_library before push vertex_table
            let oneV = GraphV.vertex_library[aVid]
                // console.log("[CHECK] reading aV : ", oneV)

            // sort
            if (lv < GraphV.info.max_level) {
                let aV_outs = oneV.v_outs.total
                let aV_dout = oneV.v_dout.total
                aV_outs.sort(function(a, b) {
                    let oa = GraphV.vertex_library[a]
                    let ob = GraphV.vertex_library[b]
                    return oa.level < ob.level ? -1 : oa.level > ob.level ? 1 : 0
                })

                ///////// weight_before ////
                let wBefore = 0.5
                    ////////////////////////////

                let px_outStart = oneV.position.x - 1.5 * GraphV.info.lv_height
                let outXSpan = (3 * GraphV.info.lv_height) / (aV_dout + 1)
                let countOut = 1
                aV_outs.forEach(o => {
                    let oV = GraphV.vertex_library[o]
                    oV.position.x = wBefore * oV.position.x + (1 - wBefore) * (px_outStart + outXSpan * countOut)
                    countOut += 1
                })
            }
            // console.log("[CHECK] reading aV.position ", oneV.position)

            vid_before_development.push(aVid)
            oneV.position.y = GraphV.info.lv_height * lv
                // keep x position

            GraphV.vertex_table.push({
                vid: aVid,
                x: oneV.position.x,
                y: oneV.position.y,
                n_nodes: oneV.n_nodes,
                nodes: oneV.nodes,
                in_d: oneV.nd_din.R,
                xwidth: xCoef * oneV.position.xd
            })
        } else {
            // console.log("Empty Level ", lv, vs_in_L)
        }
    }
    // average X
    GraphV.info.avg_r1x = sumX / GraphV.info.n_vertex

    // project x = average x of level 1
    let project_vid = GraphV.vertex_levels[0][0]
    let outx_Project = GraphV.vertex_library[project_vid].v_outs.ext

    if (outx_Project.length > 0) {
        let xs = 0
        for (let l = 0; l < outx_Project.length; l++) {
            let v_l = outx_Project[l]
            xs += GraphV.vertex_library[v_l].position.x
        }
        GraphV.info.mid_r1x = xs / outx_Project.length
    } else {
        GraphV.info.mid_r1x = xW / 2
    }

    // check xy range
    let xRight = null
    let xLeft = null
    let yMin = null
    let yMax = null

    // init - project or document
    let initV = GraphV.vertex_table[0]
    xRight = xLeft = initV.x
    yMin = yMax = initV.y

    GraphV.vertex_table.forEach(v => {
        if (v.x < xLeft) { xLeft = v.x }
        if (v.x > xRight) { xRight = v.x }
        if (v.y < yMin) { yMin = v.y }
        if (v.y > yMax) { yMax = v.y }
    })

    let xRange = xRight - xLeft
    let yRange = yMax - yMin

    // fix 1000*1000
    let xMargin = 100
    let yMargin = 100

    if (xRange == 0) {
        GraphV.info.porject_x = 500
        GraphV.vertex_table.forEach(v => {
            v.x = 500
        })
    } else if (yRange == 0) {
        // console.log("[ERROR] yRange is zero ")
    } else {
        let Cx = (1000 - 2 * xMargin) / xRange
        let Tx = xMargin - Cx * xLeft

        let Cy = (-1) * (1000 - 2 * yMargin) / yRange
        let Ty = (1000 - yMargin) - Cy * yMin

        GraphV.vertex_table.forEach(v => {
            v.x = Cx * v.x + Tx
            v.y = Cy * v.y + Ty
            GraphV.vertex_library[v.vid].position.x = v.x
            GraphV.vertex_library[v.vid].position.y = v.y
        })
    }

    initV.x = 500
    initV.y = 1000 - yMargin
    GraphV.vertex_library[0].position.x = initV.x
    GraphV.vertex_library[0].position.y = initV.y
        // console.log("[FUNCTIONS] tree_xy - finalize ", GraphV)
    return GraphV

}

export function distance_ab(A, B) {
    // a*b(intersect) / ( a + b - a*b )
    let distance_ab = 0
    let intersection = []

    if (A.length > 0 && B.length > 0) {
        intersection = A.filter(x => B.includes(x))
        distance_ab = intersection.length / (A.length + B.length - intersection.length)
    }
    return distance_ab
}


// WEBPACK FOOTER //
// ./src/custom/tree_xy.js